import React, {
  createContext, useContext, useState, useMemo,
} from 'react';
import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

const ModalContext = createContext({});

function ModalProvider({ children }) {
  const [modals, setModals] = useState([]);

  const openModal = (modal) => {
    // Prevent the React modal from opening when Onboarding or CanJs modal is already open
    const hasOnboardingOpen = !!document.documentElement.getAttribute('data-show-onboarding');
    const hasCanJsModalOpen = !!document.querySelector('.mn_lightboxContainer:not(.mn_offerOverlayWrap)');

    if (hasOnboardingOpen || hasCanJsModalOpen) {
      return;
    }

    if (modal.params) {
      modal.params = omitBy(modal.params, isUndefined);
    }

    setModals((old) => {
      // If `preventReplace` is set, skip replacing an existing open modal
      if (old.length && modal.preventReplace) {
        return old;
      }
      return [modal];
    });
  };

  const closeModal = (callback) => {
    if (typeof callback === 'function') { callback(); }
    setModals((old) => old.slice(0, old.length - 1));
  };

  const modal = modals[modals.length - 1];

  const value = useMemo(() => ({
    modal, openModal, closeModal,
  }), [modal]);

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
}

export const useModal = () => useContext(ModalContext);

export default (props) => <ComponentErrorBoundary><ModalProvider {...props} /></ComponentErrorBoundary>;
